import React, { forwardRef, useImperativeHandle, useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import { useLanguage } from '../../Context/LanguageContext';
import useDragAndDrop from '../../Model/Share/Normal/useDragAndDrop';

import { ReactComponent as DefaultLogoSvg } from '../../image/DefaultLogo.svg'
import { ReactComponent as EditSvg } from '../../image/Edit.svg'

export default function ProfileInput(props) {
  const { imgBase64, setImgBase64, isColorSubKey = false } = props;
  const { t } = useLanguage();
  
  const [imgFile, setImgFile] = useState();
  const [isUpLoad, setIsUpLoad] = useState(false);
  const [imgLocalPath, setImgLocalPath] = useState('');
  const [isErrorProfile, setIsErrorProfile] = useState(false);

  const hiddenFileInput = useRef(null);
  const FileInputRef = useRef();

  // useImperativeHandle(ref, () => ({
  //   getImgBase64: () => {
  //     return imgBase64;
  //   },
  //   setImgBase64: (val) => {
  //     setImgBase64(val);
  //     setIsUpLoad(true);
  //     setIsErrorProfile(false);
  //   },
  //   setImageFile: (val) => {
  //     setImgFile(val);
  //   },
  //   getValue: () => {
  //     return imgLocalPath;
  //   },
  //   reset: () => {
  //     setImgBase64();
  //     // setImgFile();
  //     setImgLocalPath();
  //     setIsErrorProfile(false);
  //   }
  // }));

  // 사진 변경시 에러 코드 초기화 //
  useEffect(() => {
    if (imgBase64 !== '') {
      setIsUpLoad(true);
      setIsErrorProfile(false);
    }
  }, [imgBase64])

  const handleClick = (e) => {
    hiddenFileInput.current.click();
  };

  // 파일 처리 공통 로직 (input change / drag-and-drop 공용) //
  const processFile = (file) => {
    const reader = new FileReader();
    setImgLocalPath(file.name);

    reader.onloadend = () => {
      const base64 = reader.result;
      if (base64) {
        setImgBase64(base64.toString());
        setIsUpLoad(true);
      }
    };

    reader.readAsDataURL(file);
    setImgFile(file);
  };

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const ext = file.name.split('.').pop().toLowerCase();
    if (ext !== 'jpg' && ext !== 'png' && ext !== 'jpeg') {
      alert(t('memberRegistration.profileInput.invalidFileType'));
      var parentObj = e.target.parentNode
      var node = parentObj.replaceChild(e.target.cloneNode(true), e.target);

      return false;
    }

    processFile(file);
  };

  // Drag & Drop hook //
  const { isDragOver, dragHandlers } = useDragAndDrop({
    onFileSelect: processFile,
    onInvalidFileType: () => alert(t('memberRegistration.profileInput.invalidFileType')),
  });

  const isDefault = isErrorProfile || (!imgFile && !isUpLoad);

  return (
    <TopLevelWrapper>
      <TotalWrapper>
        <LogoWrapper $isDragOver={isDragOver} $isColorSubKey={isColorSubKey} {...dragHandlers}>
          {isDefault
            ? <DefaultLogoView />
            : <Logo
                src={imgFile ? URL.createObjectURL(imgFile) : imgBase64}
                onError={() => setIsErrorProfile(true)} />
          }
          <EditIconWrapper onClick={handleClick}>
            <EditSvg width={16} height={16} />
          </EditIconWrapper>
          <input
            type="file"
            ref={hiddenFileInput}
            onChange={handleChange}
            style={{ display: 'none' }} />
        </LogoWrapper>
        {/* <InputWrapper>
          <input type="file"
            ref={hiddenFileInput}
            onChange={handleChange}
            style={{ display: 'none' }} />
          <FileInput ref={FileInputRef}>
            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={imgLocalPath === '' ? '#DBDBDB' : '#000000'} cursor='pointer'>{imgLocalPath === '' ? t('memberRegistration.profileInput.uploadPhotoPlaceholder') : imgLocalPath}</Text>
          </FileInput>
        </InputWrapper>
        <InputButton onClick={handleClick}>
          <Text fontFamily='NotoSansKR-Medium' fontSize={12} color='#FFFFFF' cursor='pointer'>{t('memberRegistration.profileInput.changePhoto')}</Text>
        </InputButton> */}
      </TotalWrapper>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const TotalWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
`;

const FileInput = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  padding: 5px 8px;

  width: 182px;
  height: 20px;
  border: 1px solid ${props => props.theme.line};
  border-radius: 5px;

  overflow: hidden;

  transition: all 0.5s ease-in-out;
`;

const InputButton = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 55px;
  height: 32px;

  border-radius: 5px;
  background-color: ${props => props.theme.line};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const LogoWrapper = styled.div`
  position: relative;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  width: 107px;
  height: 107px;
  box-sizing: border-box;

  background: ${props => props.theme.background};
  border: 2px solid ${props => props.$isDragOver ? (props.$isColorSubKey ? props.theme.subKey : props.theme.primary) : 'transparent'};
  border-radius: 5px;

  overflow: hidden;

  transition: border-color 0.2s ease-in-out;
`;

const DefaultLogoView = styled(DefaultLogoSvg)`
  width: 54.86px;
  height: 54.86px;

  & path:nth-child(1) { fill: ${props => props.theme.logo1}; }
  & path:nth-child(2) { fill: ${props => props.theme.logo2}; }
  & path:nth-child(3) { fill: ${props => props.theme.logo1}; }
  & path:nth-child(4) { fill: ${props => props.theme.logo3}; }
`;

const Logo = styled.img`
  width: 100%;
  height: 100%;

  object-fit: cover;
`;

const EditIconWrapper = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 26px;
  height: 26px;

  top: 0;
  left: 81px;

  background: ${({ theme }) => theme.blackAlpha10};
  border-radius: 0px 0px 0px 5px;

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: pointer;
    }
  }

  & path {
    fill: ${({ theme }) => theme.white};
  }
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  margin: 0 0 0 0;

  color: ${props => props.color};

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      cursor: ${props => props.cursor};
    }
  }
`;